/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-31 10:21:40
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { Banner, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';

type ComposedProps = Props & WithI18nProps;

class UpgradeSuccessBanner extends Component<ComposedProps> {
  state = {
    dismissedBanner: false
  };
  componentDidMount() {
    // Hide banner
    this.checkDismissedBanner();
  }

  render() {
    const { dismissedBanner } = this.state;
    const { i18n } = this.props;

    return (
      !dismissedBanner && (
        <div style={{ marginBottom: '24px' }}>
          <Banner
            title={i18n.translate(
              'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessTitle'
            )}
            status="success"
            onDismiss={this.onDismiss}>
            <p>
              <p>
                {i18n.translate(
                  'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessLabel'
                )}
              </p>

              <ul style={{ marginTop: '0', paddingLeft: '20px' }}>
                <li>
                  {i18n.translate(
                    'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessContent01',
                    {
                      t1: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessContent01_t1'
                          )}
                        </TextStyle>
                      ),
                      t2: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessContent01_t2'
                          )}
                        </TextStyle>
                      )
                    }
                  )}
                </li>
                <li>
                  {i18n.translate(
                    'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessContent02',
                    {
                      t1: (
                        <TextStyle variation="strong">
                          {i18n.translate(
                            'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.updateSuccessContent02_t1'
                          )}
                        </TextStyle>
                      )
                    }
                  )}
                </li>
              </ul>
            </p>
          </Banner>
        </div>
      )
    );
  }

  // Get dismissed banner status
  checkDismissedBanner = () => {
    const shop = getShop();
    let dismissed = false;
    let count = 0;

    try {
      dismissed = localStorage.getItem(`${shop}-dismissBannerUpgradeSuccessStatusSearchV2`);
      count = localStorage.getItem(`${shop}-countBannerUpgradeSuccessStatusSearchV2`) || 0;
      if (parseInt(count) < 3) {
        localStorage.setItem(
          `${shop}-countBannerUpgradeSuccessStatusSearchV2`,
          `${parseInt(count) + 1}`
        );
      } else {
        this.onDismiss();
      }
    } catch (error) {}

    if (dismissed === 'true') {
      this.setState({ dismissedBanner: true });
    }
  };

  // Handle hide banner
  onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(`${shop}-dismissBannerUpgradeSuccessStatusSearchV2`, `true`);
    } catch (error) {}

    // Hide banner
    this.setState({ dismissedBanner: true });
  };
}

export default withI18n()(UpgradeSuccessBanner);
